// Fallback-копи (spec §9). Тихие italic-строки для пустых/тонких этапов.
//
// КОПИ = web-Claude (Q-empty-slot-fallbacks, CD R8) — открытая зависимость
// (спека §12). Пока — указатели-заглушки, чтобы рендер не падал. НЕ финальный
// текст. См. CLAUDE.md: UI-смыслы единолично не сочиняем.

/** §VI: пустой этап — вместо цитаты тихая italic-строка (карточка остаётся). */
export const SILENT_QUOTE_FALLBACK =
  '[TODO: UI text — web-Claude · §VI empty-stage italic, напр. «you left this one unsaid.»]';

/** §VII Slot A — current пуст. */
export const SLOT_A_FALLBACK =
  '[TODO: UI text — web-Claude · §VII Slot A static fallback]';

/** §VII Slot C — penultimate пуст. */
export const SLOT_C_FALLBACK =
  '[TODO: UI text — web-Claude · §VII Slot C static fallback]';

/** §VII Slot F — current пуст. */
export const SLOT_F_FALLBACK =
  '[TODO: UI text — web-Claude · §VII Slot F static fallback]';
